var pug = require("!../../../../../../../node_modules/pug-runtime/index.js");

function template(locals) {
var buf = [];
var jade_mixins = {};
var jade_interp;
;var locals_for_with = (locals || {});(function (artists, undefined) {
buf.push("<div class=\"abrv-context__content abrv-context__content--iconic-artists\">");
// iterate artists
;(function(){
  var $$obj = artists;
  if ('number' == typeof $$obj.length) {

    for (var $index = 0, $$l = $$obj.length; $index < $$l; $index++) {
      var artist = $$obj[$index];

buf.push("<a" + (jade.attr("href", "/artist/" + (artist.id) + "", true, true)) + " class=\"abrv-context__content--iconic-artists__artist\">" + (jade.escape(null == (jade_interp = artist.name) ? "" : jade_interp)) + "</a>");
    }

  } else {
    var $$l = 0;
    for (var $index in $$obj) {
      $$l++;      var artist = $$obj[$index];

buf.push("<a" + (jade.attr("href", "/artist/" + (artist.id) + "", true, true)) + " class=\"abrv-context__content--iconic-artists__artist\">" + (jade.escape(null == (jade_interp = artist.name) ? "" : jade_interp)) + "</a>");
    }

  }
}).call(this);

buf.push("</div>");}.call(this,"artists" in locals_for_with?locals_for_with.artists:typeof artists!=="undefined"?artists:undefined,"undefined" in locals_for_with?locals_for_with.undefined:typeof undefined!=="undefined"?undefined:undefined));;return buf.join("");
};
module.exports = template;